import { InfoCircleOutlined } from "@ant-design/icons";
import {
	Button,
	Card,
	Col,
	Form,
	Input,
	Row,
	Select,
	Table,
	Tooltip,
	Typography
} from "antd";


import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
	addSingleWeeklyHoliday,
	loadAllWeeklyHoliday,
} from "../../redux/rtk/features/weeklyHoliday/weeklyHolidaySlice";



import ViewBtn from "../Buttons/ViewBtn";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import ColVisibilityDropdown from "../Shared/ColVisibilityDropdown";
function CustomTable({ list, loading }) {
	const [columnsToShow, setColumnsToShow] = useState([]);

	const columns = [
		{
			id: 1,
			title: "S.No",
			dataIndex: "serial",
			key: "serial",
		},
		{
			id: 2,
			title: "Name",
			dataIndex: "name",
			key: "name",
		},

		{
			id: 3,
			title: "Week Start Day",
			dataIndex: "startDay",
			key: "startDay",
		},

		{
			id: 3,
			title: "Week End Day",
			dataIndex: "endDay",
			key: "endDay",
		},
		{
			id: 4,
			title: "Action",
			dataIndex: "id",
			key: "action",
			render: (id) => <ViewBtn path={`/admin/holiday/week/${id}/`} />,
		},
	];

	useEffect(() => {
		setColumnsToShow(columns);
	}, []);

	const columnsToShowHandler = (val) => {
		setColumnsToShow(val);
	};

	// const addKeys = (arr) => arr.map((i) => ({ ...i, key: i.id }));
	const addKeys = (arr) => arr.map((i, index) => ({ ...i, key: i.id, serial: index + 1 }));


	return (
		<Card>
			<div className='text-center my-2 flex justify-between'>
				<h5 className='department-list-title text-color-2 text-xl mb-2'>
					Weekly Working Day List
				</h5>
				{/* {list && (
					<div>
						<CsvLinkBtn>
							<CSVLink
								data={list}
								className='btn btn-dark btn-sm mb-1'
								filename='weekly-holiday'>
								Download CSV
							</CSVLink>
						</CsvLinkBtn>
					</div>
				)} */}
			</div>

			{list && (
				<div style={{ marginBottom: "30px" }}>
					<ColVisibilityDropdown
						options={columns}
						columns={columns}
						columnsToShowHandler={columnsToShowHandler}
					/>
				</div>
			)}

			<Table
				scroll={{ x: true }}
				loading={!list || loading}
				columns={columnsToShow}
				dataSource={list ? addKeys(list) : []}
			/>
		</Card>
	);
}

const AddWeeklyHoliday = ({ drawer }) => {
	const { list, loading } = useSelector((state) => state.weeklyHoliday);
	const [loader, setLoader] = useState(false);
	const [form] = Form.useForm();
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(loadAllWeeklyHoliday());
	}, []);

	const { Title } = Typography;

	const onFinish = async (values) => {
		setLoader(true);
		const resp = await dispatch(addSingleWeeklyHoliday(values));

		if (resp.payload.message === "success") {
			setLoader(false);
			form.resetFields();
			dispatch(loadAllWeeklyHoliday());
		} else {
			setLoader(false);
		}
	};

	const onFinishFailed = (errorInfo) => {
		toast.warning("Failed at adding weekly holiday");
		setLoader(false);
	};
	const weekOptions = [1, 2, 3, 4, 5];
	const daysOfWeek = [
		"Saturday",
		"Sunday",
		"Monday",
		"Tuesday",
		"Wednesday",
		"Thursday",
		"Friday",
	];
	// return (
	// 	<Fragment bordered={false}>
	// 		<UserPrivateComponent permission={"create-weeklyHoliday"}>
	// 			<Row className='mr-top' justify={drawer ? "center" : "space-between"}>
	// 				<Col
	// 					xs={24}
	// 					sm={24}
	// 					md={24}
	// 					lg={drawer ? 22 : 12}
	// 					xl={drawer ? 22 : 12}
	// 					className='column-design border rounded card-custom'>
	// 					<Title level={4} className='m-2 mt-5 mb-5 text-center'>
	// 						Add Weekly Work Days
	// 					</Title>
	// 					<Form
	// 						style={{ marginBottom: "40px" }}
	// 						form={form}
	// 						eventKey='department-form'
	// 						name='basic'
	// 						labelCol={{
	// 							span: 6,
	// 						}}
	// 						wrapperCol={{
	// 							span: 12,
	// 						}}
	// 						onFinish={onFinish}
	// 						onFinishFailed={onFinishFailed}
	// 						autoComplete='off'>
	// 						<div>
	// 							<Form.Item
	// 								style={{ marginBottom: "10px" }}
	// 								label='Name'
	// 								name='name'
	// 								rules={[
	// 									{
	// 										required: true,
	// 										message: "Please input name!",
	// 									},
	// 								]}>
	// 								<Input placeholder='Saturday-Friday' />
	// 							</Form.Item>

	// 							<Form.Item
	// 								style={{ marginBottom: "10px" }}
	// 								// label='Start Day'
	// 								label={
	// 									<span>
	// 										Start Day
	// 										<Tooltip title="Select working week start day">
	// 											<InfoCircleOutlined style={{ marginLeft: "5px" }} />
	// 										</Tooltip>
	// 									</span>
	// 								}
	// 								name='startDay'
	// 								rules={[
	// 									{
	// 										required: true,
	// 										message: "Please input start day!",
	// 									},
	// 								]}>
	// 								<Select placeholder='Select Start Day'>
	// 									<Select.Option value='Saturday'>Saturday</Select.Option>
	// 									<Select.Option value='Sunday'>Sunday</Select.Option>
	// 									<Select.Option value='Monday'>Monday</Select.Option>
	// 									<Select.Option value='Tuesday'>Tuesday</Select.Option>
	// 									<Select.Option value='Wednesday'>Wednesday</Select.Option>
	// 									<Select.Option value='Thursday'>Thursday</Select.Option>
	// 									<Select.Option value='Friday'>Friday</Select.Option>
	// 								</Select>
	// 							</Form.Item>

	// 							<Form.Item
	// 								style={{ marginBottom: "10px" }}
	// 								// label='End Day'
	// 								label={
	// 									<span>
	// 										End Day
	// 										<Tooltip title="Select working week end day">
	// 											<InfoCircleOutlined style={{ marginLeft: "5px" }} />
	// 										</Tooltip>
	// 									</span>
	// 								}
	// 								name='endDay'
	// 								rules={[
	// 									{
	// 										required: true,
	// 										message: "Please input End day!",
	// 									},
	// 								]}>
	// 								<Select placeholder='Select Start Day'>
	// 									<Select.Option value='Saturday'>Saturday</Select.Option>
	// 									<Select.Option value='Sunday'>Sunday</Select.Option>
	// 									<Select.Option value='Monday'>Monday</Select.Option>
	// 									<Select.Option value='Tuesday'>Tuesday</Select.Option>
	// 									<Select.Option value='Wednesday'>Wednesday</Select.Option>
	// 									<Select.Option value='Thursday'>Thursday</Select.Option>
	// 									<Select.Option value='Friday'>Friday</Select.Option>
	// 								</Select>
	// 							</Form.Item>
	// 							<Form.Item
	// 								style={{ marginBottom: "10px" }}
	// 								// label='Special Off Week'
	// 								label={
	// 									<span>
	// 										Special Off Week
	// 										<Tooltip title="Select week number for special off">
	// 											<InfoCircleOutlined style={{ marginLeft: "5px" }} />
	// 										</Tooltip>
	// 									</span>
	// 								}
	// 								name='specialOffWeek'>
	// 								<Select
	// 									placeholder='Select Weeks'
	// 									mode='multiple'
	// 									optionLabelProp='label'>
	// 									{weekOptions.map((week) => (
	// 										<Select.Option key={week} value={week} label={`Week ${week}`}>
	// 											{/* <Checkbox value={week}>Week {week}</Checkbox> */}
	// 										</Select.Option>
	// 									))}
	// 								</Select>
	// 							</Form.Item>

	// 							<Form.Item
	// 								style={{ marginBottom: "10px" }}
	// 								// label='Special Off Day'
	// 								label={
	// 									<span>
	// 										Special Off Day
	// 										<Tooltip title="Select days for special off">
	// 											<InfoCircleOutlined style={{ marginLeft: "5px" }} />
	// 										</Tooltip>
	// 									</span>
	// 								}
	// 								name='specialOffDay'>
	// 								<Select
	// 									placeholder='Select Days'
	// 									mode='multiple'
	// 									optionLabelProp='label'>
	// 									{daysOfWeek.map((day) => (
	// 										<Select.Option key={day} value={day} label={day}>
	// 											{/* <Checkbox value={day}>{day}</Checkbox> */}
	// 										</Select.Option>
	// 									))}
	// 								</Select>
	// 							</Form.Item>

	// 							<Form.Item
	// 								style={{ marginBottom: "10px" }}
	// 								wrapperCol={{
	// 									offset: 6,
	// 									span: 12,
	// 								}}>
	// 								<Button
	// 									onClick={() => setLoader(true)}
	// 									type='primary'
	// 									size='large'
	// 									htmlType='submit'
	// 									block
	// 									loading={loader}>
	// 									Add Weekly Holiday
	// 								</Button>
	// 							</Form.Item>
	// 						</div>
	// 					</Form>
	// 				</Col>


	// 			</Row>
	// 		</UserPrivateComponent>
	// 		<hr />
	// 		<UserPrivateComponent permission={"readAll-weeklyHoliday"}>
	// 			{drawer || <CustomTable list={list} loading={loading} />}
	// 		</UserPrivateComponent>
	// 	</Fragment>
	// );

	return (
		<Fragment bordered={false}>
			<UserPrivateComponent permission={"create-weeklyHoliday"}>
				<Row className="mt-5" justify="space-between" gutter={[16, 16]}>
					{/* Form Column */}
					<Col
						xs={24}
						sm={24}
						md={12}
						lg={12}
						xl={12}
						className="column-design border rounded card-custom">
						<Title level={4} className="m-2 mt-5 mb-5 text-center">
							Add Weekly Work Days
						</Title>
						<Form
							style={{ marginBottom: "40px" }}
							form={form}
							eventKey="weeklyOff-form"
							name="basic"
							// layout="vertical"
							labelCol={{ span: 6 }}
							wrapperCol={{ span: 12 }}
							onFinish={onFinish}
							onFinishFailed={onFinishFailed}
							autoComplete="off">
							<div>
								<Form.Item
									style={{ marginBottom: "10px" }}
									label="Name"
									name="name"
									rules={[{ required: true, message: "Please input name!" }]}>
									<Input placeholder="Saturday-Friday" />
								</Form.Item>

								<Form.Item
									style={{ marginBottom: "10px" }}
									label={
										<span>
											Start Day
											<Tooltip title="Select working week start day">
												<InfoCircleOutlined style={{ marginLeft: "5px" }} />
											</Tooltip>
										</span>
									}
									name="startDay"
									rules={[{ required: true, message: "Please input start day!" }]}>
									<Select placeholder="Select Start Day">
										{["Saturday", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday"].map((day) => (
											<Select.Option key={day} value={day}>
												{day}
											</Select.Option>
										))}
									</Select>
								</Form.Item>

								<Form.Item
									style={{ marginBottom: "10px" }}
									label={
										<span>
											End Day
											<Tooltip title="Select working week end day">
												<InfoCircleOutlined style={{ marginLeft: "5px" }} />
											</Tooltip>
										</span>
									}
									name="endDay"
									rules={[{ required: true, message: "Please input End day!" }]}>
									<Select placeholder="Select End Day">
										{["Saturday", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday"].map((day) => (
											<Select.Option key={day} value={day}>
												{day}
											</Select.Option>
										))}
									</Select>
								</Form.Item>

								<Form.Item
									style={{ marginBottom: "10px" }}
									label={
										<span>
											Special Off Week
											<Tooltip title="Select week number for special off">
												<InfoCircleOutlined style={{ marginLeft: "5px" }} />
											</Tooltip>
										</span>
									}
									name="specialOffWeek">
									<Select placeholder="Select Weeks" mode="multiple" optionLabelProp="label">
										{weekOptions.map((week) => (
											<Select.Option key={week} value={week} label={`Week ${week}`} />
										))}
									</Select>
								</Form.Item>

								<Form.Item
									style={{ marginBottom: "10px" }}
									label={
										<span>
											Special Off Day
											<Tooltip title="Select days for special off">
												<InfoCircleOutlined style={{ marginLeft: "5px" }} />
											</Tooltip>
										</span>
									}
									name="specialOffDay">
									<Select placeholder="Select Days" mode="multiple" optionLabelProp="label">
										{daysOfWeek.map((day) => (
											<Select.Option key={day} value={day} label={day} />
										))}
									</Select>
								</Form.Item>

								<Form.Item
									style={{ marginBottom: "10px" }}
									wrapperCol={{ offset: 6, span: 12 }}>
									<Button
										onClick={() => setLoader(true)}
										type="primary"
										size="large"
										htmlType="submit"
										block
										loading={loader}>
										Add Weekly Holiday
									</Button>
								</Form.Item>
							</div>
						</Form>
					</Col>

					{/* Table Column */}
					<Col xs={24} sm={24} md={12} lg={12} xl={12}>
						<UserPrivateComponent permission={"readAll-weeklyHoliday"}>
							<CustomTable list={list} loading={loading} />
						</UserPrivateComponent>
					</Col>
				</Row>
			</UserPrivateComponent>
		</Fragment>
	);


};

export default AddWeeklyHoliday;
